import { ActivityTask, TaskStatus } from "./activity-task.model";
import { Recurrence } from "@models/recurrence.model";

export class TicketOperationTask {

    public id: number;
    public operationTask: ActivityTask;
    public status: TaskStatus;
    public comment: string;
    public notDoneReason: string;
    public spareQuantity: number;
    public endDate: string;
    public completedByName: string;
    public previousTaskId: number;
    public previousTicketId: number;
    public requiresObservation: boolean;
    public requiresSpare: boolean;
    public recurrences: Recurrence[];

    constructor(ticketOperationTask: any = {}) {
        if (!ticketOperationTask) {
            return new TicketOperationTask();
        }
        this.id = ticketOperationTask.id || 0;
        this.operationTask = this.mapTask(ticketOperationTask.operationTask);
        this.status = ticketOperationTask.status;
        this.comment = ticketOperationTask.comment;
        this.notDoneReason = ticketOperationTask.notDoneReason;
        this.spareQuantity = ticketOperationTask.spareQuantity;
        this.endDate = ticketOperationTask.endDate;
        this.completedByName = ticketOperationTask.completedByName;
        this.previousTaskId = ticketOperationTask.previousTaskId;
        this.previousTicketId = ticketOperationTask.previousTicketId;
        this.requiresSpare = ticketOperationTask.requiresSpare;
        this.requiresObservation = ticketOperationTask.requiresObservation;
        this.recurrences = ticketOperationTask.recurrences;
    }

    mapTask(operationTask) {
      return operationTask ? new ActivityTask(operationTask) : new ActivityTask();
    }

    static get type() {
        return 'ticket-operation-task';
    }
}
